import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const POLL_MS = 60000;

export function useDiwaliCampaign() {
  const [status, setStatus] = useState(null); // null = loading
  const [error, setError] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/campaign/diwali/status");
      setStatus(data);
      setError(false);
    } catch {
      setError(true);
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, POLL_MS);
    return () => clearInterval(id);
  }, [refresh]);

  return { status, loading: status === null && !error, error, refresh };
}
